import React from 'react'
import { Controller } from 'react-hook-form'

import { INumberInputRange, NumberInputRange } from './number-input-range'

export interface IControlledNumberInputRangeProps extends INumberInputRange {
  control: any
  rules?: any
  name: any
  message?: string
  defaultValue?: number
}

export default function ControlledNumberInputRange({
  control,
  rules = {},
  name,
  defaultValue,
  onChange,
  ...props
}: IControlledNumberInputRangeProps) {
  return (
    <Controller
      control={control}
      rules={rules}
      render={({ field }) => {
        return (
          <NumberInputRange
            {...field}
            value={field.value ?? defaultValue}
            onChange={(value) => {
              field.onChange(value), onChange?.(value)
            }}
            {...props}
          />
        )
      }}
      name={name}
    />
  )
}
